import React from "react";
import { getAttyStatusFromId } from "../../../lib/labels";

export default function AttyPart({activeCase, classes}) {
    return <>
        {activeCase.attorneys && activeCase.attorneys.length> 0 && activeCase.attorneys.filter(item => item.active).map(atty => (
            <React.Fragment key={atty.id}>
                <h4 className={classes.flex_betwen}>Attorney <div className={classes.status}>{getAttyStatusFromId(atty.status_id)}</div></h4>
                <div className={classes.background_container}>
                    {atty.law_firm && <>
                        <div className={classes.row}><b>{atty.law_firm?.name}</b></div>
                    </>}
                    {atty.location && <>
                        <div className={classes.row}>Loc: <b>{atty.location?.name}</b></div>
                    </>}
                    {atty.attorney && <>
                        <div className={classes.row}>Atty: <b>{atty.attorney?.first_name} {atty.attorney?.last_name}</b>{atty.attorney?.contact_information?.phone && <>, <b>{atty.attorney?.contact_information?.phone}</b></>}</div>
                    </>}
                    {atty.case_manager && <>
                        <div className={classes.row}>CM: <b>{atty.case_manager?.first_name} {atty.case_manager?.last_name}</b>{atty.case_manager?.contact_information?.phone && <>, <b>{atty.case_manager?.contact_information?.phone}</b></>}</div>
                    </>}
                </div>
            </React.Fragment>
        ))}  
    </>
}